import Badge from "../../components/badge";
import Card from "../../components/card";
import { useLayoutContext } from "../../context/game";
export default function Answers({setRoute}){
	const [context] = useLayoutContext();
	const game_data = window.game_data;
	const questionIds = Object.keys(game_data?.questions || {});
	return(
		<div className="container my-4">
			<Card>
				<div style={{textAlign:'left'}}>
					<Back setRoute={setRoute}/>
				</div>
				<h1 className="mb-5">Atsakymų sąrašas</h1>
				
				<div className="row justify-content-center">
					{questionIds.map((id, index)=>{
						const text = game_data.questions[id]?.text;
						const img = game_data.questions[id]?.img;
						const options = Object.keys(game_data.options[id] || {});
						const correct = game_data.answers[id];
						const contextAnswered = context?.answeredList || {};
						const answered = contextAnswered[id];
						const isWrong = correct !== answered;
						return(
							<div key={'question' + id} className="col-lg-6">
								<div className="py-3 mb-4">
									<Badge className='d-inline-block'>
										Klausimas nr. {index + 1}
									</Badge>
									<hr />
									<div className="question-text mb-4 py-3">{text}</div>
									{img && (
										<div className="question-img-wrap mb-3">
											<img src={img} alt={text} className="question-img" />
										</div>
									)}
									{options.map((answerId)=>{
										const text = game_data.options[id][answerId];
										const userSelected = answerId === answered;
										return(
											<div className={`quiz-option p-2 mb-1${userSelected ? ' quiz-option--selected' :''}${isWrong?' quiz-option--wrong':''}`} key={'answer' + id + answerId}>
												{
													answerId === correct?(
														<span>✅</span>
													):(
														<span>❌</span>
													)
												}
												{/* {userSelected &&(
													<small style={{fontSize:14,color:'#666'}}>Jūs pažymėjote</small>
												)} */}
												<span>{text}</span>
											</div>
										)
									})}
								</div>
							</div>
						)
					})}
				</div>
				<div style={{textAlign:'right'}}>
					<Back setRoute={setRoute} />
				</div>
			</Card>
		</div>
	)
}

function Back({setRoute}) {
	const btn = {
		color: '#163C60',
		fontWeight: '600',
		display: 'inline-flex',
		alignItems: 'center',
		padding: '.5rem',
		border: 'none',
		background: 'transparent'
	}
	return (
		<button onClick={() => { setRoute('title') }} style={btn}>
			<svg className="me-3" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M3.828 7.00066H16V9.00066H3.828L9.192 14.3647L7.778 15.7787L0 8.00066L7.778 0.222656L9.192 1.63666L3.828 7.00066Z" fill="currentColor" />
			</svg>
			Grįžti
		</button>
	)
}